'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateActiveCurrencyCode = undefined;

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateActiveCurrencyCode = exports.updateActiveCurrencyCode = function updateActiveCurrencyCode(payload) {
  return {
    type: _ActionTypes2.default.ACTIVE_CURRENCY_CODE_UPDATED,
    payload: payload
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/ActiveCurrencyCodeActions.js
// module id = 549
// module chunks = 3 4